{
  "#PRODUKTION_ROHSTOFFBEREITSTELLUNG": {
    "TITLE": "Rohstoffbereitstellung"
  }
}
